import React, { useState, useEffect } from 'react';
import styles from './subscribe_success.module.css';
import { useTranslation } from 'react-i18next';

const SubscribeConfirm = () => {
  const { t, i18n } = useTranslation();

  return (
    <div class="container"
      style={{paddingLeft: 32}}
    >
      <div class="row py-5">
        <div class="breadcrumb1 col-12">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="#">Home</a></li>
              <li className="breadcrumb-item"><a href="#">Mi cuenta</a></li>
              <li className="breadcrumb-item active" aria-current="page">Confirmación de subscripción</li>
            </ol>
          </nav>
        </div>
        <div class="row" style={{
          width: '100%'
        }}>
          <div class="col-md-12">
            <h2>Confirmación</h2>

            <div className={`row ${styles.payment}`}>
              <div class="col-lg-12 mb-4 mb-lg-0">

                <div class="mensajeConfirmacion text-center mx-auto" style={{ maxWidth: 767 }}>
                  <h5>{t('subscription.subscribesucces.title')}</h5>
                  <h6>{t('subscription.subscribesucces.subtitle')}</h6>
                  <p>
                    {t('subscription.subscribesucces.message')}
                    <a href="mailto:contacto@chungungo.com">{t('subscription.subscribesucces.mail')}</a>.
                  </p>
                  <a class="btn btn-primary" href="/seasons">{t('subscription.subscribesucces.mail')}</a>.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscribeConfirm;